import styled from 'styled-components';
import { COLORS, SURFACES } from '~styles/tokens';

export const BREAKPOINTS = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1280px',
} as const;

export const ShellContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${SURFACES.canvas};
`;

export const MainWrapper = styled.div`
  display: flex;
  margin: 0.625rem auto 0;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
  position: relative;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    flex-direction: column;
  }
`;

export const ContentArea = styled.main`
  flex: 1;
  min-width: 0;
  max-width: 100%;
  padding: 0 20px 20px;
  padding-left: 36px;
  background-color: ${SURFACES.canvas};
  overflow-x: hidden;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 0 0.5rem 20px;
  }
`;

export const CollapseToggleButton = styled.button<{ $collapsed?: boolean }>`
  position: absolute;
  left: ${({ $collapsed }) => ($collapsed ? '4rem' : '15.125rem')};
  top: 1.5rem;
  transform: translateX(-50%);
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: ${SURFACES.card};
  border: 1px solid ${COLORS.borderDefault};
  border-radius: 50%;
  cursor: pointer;
  color: ${COLORS.textTertiary};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  svg {
    width: 14px;
    height: 14px;
    transition: transform 0.3s ease;
  }

  &:hover {
    background-color: ${SURFACES.alternative};
    color: ${COLORS.textPrimary};
    border-color: ${COLORS.borderStrong};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    display: none;
  }
`;
